import { createFileRoute } from "@tanstack/react-router";
import { ContactContent } from "@/components/pages/ContactContent";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/contact")({
  // Section copy is edited in Admin → CMS Pages → Contact.
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("contact")),
  head: () => ({ meta: [
    { title: "Contact CB16 — Concierge, Showroom & Press" },
    { name: "description", content: "Reach the CB16 concierge, our Mumbai showroom, or press office." },
    { property: "og:title", content: "Contact CB16" },
    { property: "og:description", content: "Reach the CB16 concierge, our Mumbai showroom, or press office." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
    { property: "og:url", content: canonicalUrl("/contact") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/contact") }] }),
  component: ContactContent,
});